module.exports = __webpack_public_path__ + "img/digiti2.4b99f2bb.svg";